<template>
  <div class="container" style="display: flex; flex-direction: column;height: 100%">
    <div class="signup-logo" style="margin-top: 56px">
      <img src="../../../assets/image/ic_logo@2x.png" style="width: 80px; height: 80px; margin-top: 80px;"/>
      <div class="login_text" style="margin-top: 50px; margin-bottom: 30px;">{{$t('login.login')}}</div>
    </div>
    <b-input-group style="margin-top: 39px; align-items: flex-end">
      <b-form-input v-model="phone" @change="onPhoneNumber" class="input_wrapper input" :placeholder="$t('login.phone_placeholder')" :formatter="u.formatPhoneNumber"></b-form-input>
      <b-input-group-append>
        <b-button class="outline_btn btn_label" pill variant="white" @click="onPhoneNumber()">{{$t('login.send_auth_num')}}</b-button>
      </b-input-group-append>
    </b-input-group>
    <b-input-group style="margin-top: 70px;  align-items: flex-end">
      <b-form-input v-model="code"  @change="onAuthNumber" class="input_wrapper input"  v-bind:placeholder="$t('login.auth_placeholder')" :formatter="u.formatNumber1"></b-form-input>
      <b-input-group-append>
        <label v-if="leftTime > 0" class="counter">{{timeStr()}}</label>
        <b-button class="outline_btn1 btn_label1 center" pill variant="primary" @click="onAuthNumber()">{{$t('login.login')}}</b-button>
      </b-input-group-append>
    </b-input-group>
    <div style="flex: 1"/>
    <b-button class="signup_btn signup_label" @click="$router.push('signupInfo')">{{$t('login.signup')}}</b-button>
  </div>
</template>

<script>
import Utils from '../../../config/utils'

export default {
  name: "Login",
  timer: null,
  data () {
    return {
      u:Utils,
      phone: '',
      code: '',
      leftTime: 0,
      sendAuth: false,
      isLoad: false,
    }
  },
  methods: {
    timeStr() {
      return Utils.formatTime(this.leftTime);
    },
    startTimer() {
      this.leftTime = 180;
      this.timer = setInterval(() => {
        this.leftTime--;
        if (this.leftTime == 0)
          this.stopTimer();
      }, 1000);
    },
    stopTimer() {
      if (this.timer != null)
        clearInterval(this.timer);
      this.leftTime = 180;
      this.sendAuth = false;
    },
    onPhoneNumber() {
      if (this.phone === '') {
        Utils.toast(this, this.$t('login.phone_placeholder'));
        return;
      }
      Utils.requestPost(this.$c.API.Auth.authPhone, {
        phone_number: this.phone.replace(new RegExp(/-/g), ''),
        is_login: 'Y'
      }).then(result => {
        if (result == null)
          return;
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this, this.$t('login.auth_num_sent'));
          this.startTimer();
          this.sendAuth = true;
        } else {
          if (this.leftTime < 1) {
            this.sendAuth = false;
          }
          Utils.toast(this, result.msg);
        }
      }).catch(err => {
        Utils.toast(this, this.$t('app_error.network'));
      });
    },
    onAuthNumber() {
      if (this.code === '') {
        Utils.toast(this, this.$t('login.auth_placeholder'));
        return;
      }
      if (!this.sendAuth) {
        Utils.toast(this, this.$t('login.auth_num_request'));
        return;
      }
      if (this.leftTime < 1) {
        Utils.toast(this, this.$t('login.time_out'));
        return;
      }
      this.login();
    },
    login() {
      if (this.isLoad) {
        return;
      }
      this.isLoad = true;
      Utils.requestPost(this.$c.API.Auth.login, {
        phone_number: this.phone.replace(new RegExp(/-/g), ''),
        code: this.code,
        device_id: this.$perf.uuid(),
        // fcm_token: this.$perf.fcm_token(),
        auto_login: 'N',
        isWeb: 'Y'
      }, false).then(result => {
        this.isLoad = false;
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.accessToken = result.data.access_token;
          // this.$perf.setString('accessToken', result.data.access_token);
          this.$perf.setString(this.$c.PREF_PARAMS.PHONE, this.phone.replace(new RegExp(/-/g), ''));
          this.$perf.setString(this.$c.PREF_PARAMS.CODE, this.code);
          this.getProfile();
        }else if (result.code == this.$c.API_RES_CODE.RESULT_CERT_ANSWER) {
          this.$router.push('/SignupQuiz');
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
    getProfile() {
      Utils.requestGet(this.$c.API.User.getProfile).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.transformData(result.data);
          console.log(result.data);
          this.myinfo.saveInfo();
          this.myinfo.loadInfo();
          this.$router.push('/Home');
        } else {
          // Utils.toast(this, result.msg);
        }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/auth/Login';
@import "../../../assets/css/auth/SignupInfo";
</style>



// WEBPACK FOOTER //
// src/components/contents/auth/Login.vue